<template>
  <div class="main-body fill-height">
    <OnboardingNav />
    <!-- onboarding 4th step -->
    <v-layout row wrap class="row fill-height" id="onboarding-4">
      <v-flex xs3 md3 lg3 class="flex1">
        <div class="content-area">
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-check-circle-outline</v-icon> Add a
              Brand/Location
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-check-circle-outline</v-icon> Add Staff
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-check-circle-outline</v-icon> Menu
              Category
            </p>
            <v-divider />
          </div>
          <div class="content-list">
            <p>
              <v-icon class="icon">mdi-checkbox-blank-circle-outline</v-icon>
              Menu Setup
            </p>
            <v-divider />
          </div>
        </div>
        <div class="footer">
          <p><router-link to="/" class="link">Exit Setup</router-link></p>
        </div>
      </v-flex>
      <v-flex xs9 md9 lg9 class="flex2">
        <div class="flex2-content">
          <h4>What are you selling?</h4>
          <span
            >This is your trademark, what defines your business. You may choose
            to upload your menu as a batch later
          </span>
          <div>
            <v-form ref="onboarding4">
              <v-layout
                row
                wrap
                v-for="(dishNsubCat, index) in dishNsubCatHolder"
                :key="index"
              >
                <v-flex xs12 md4 lg4>
                  <div class="form-group">
                    <v-text-field
                      v-model="dishNsubCatHolder[index].name"
                      outlined
                      dense
                      height="48"
                      label="Dish Name"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 md4 lg4>
                  <div class="form-group">
                    <v-select
                      outlined
                      v-model="dishNsubCatHolder[index].categories"
                      :items="categories"
                      item-text="name"
                      item-value="id"
                      dense
                      height="48"
                      label="Select Category"
                      :rules="[rules.required]"
                    ></v-select>
                  </div>
                </v-flex>
                <v-flex xs12 md4 lg4>
                  <div class="form-group">
                    <v-text-field
                      outlined
                      v-model="dishNsubCatHolder[index].price"
                      dense
                      height="48"
                      label="Price(﷼) - 0.00"
                      :rules="[rules.required, rules.number]"
                    ></v-text-field>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <v-btn class="error btn-add-more" @click="addMore">
            <v-icon>mdi-plus</v-icon>
            Add more
          </v-btn>
          <div style="padding-top: 18%">
            <v-layout row wrap>
              <v-flex xs2 md2 lg2>
                <v-btn><v-icon>mdi-step-backward</v-icon></v-btn>
              </v-flex>
              <v-flex xs2 md7 lg7>
                <strong style="font-size: 16px"
                  >You can upload menu as a batch, click here to upload</strong
                >
              </v-flex>
              <v-flex xs6 md3 lg3>
                <v-btn
                  class="success"
                  :loading="nextLoading"
                  id="next-btn"
                  @click="processNextStage"
                >
                  Let's go
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import OnboardingNav from "../../components/onboarding/OnboardingNav";
import { mapState } from "vuex";
import axios from "axios";

export default {
  components: {
    OnboardingNav,
  },
  data() {
    return {
      dishNsubCatHolder: [{ name: "", categories: "", price: "" }],
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      nextLoading: false,
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    async processNextStage() {
      if (this.$refs.onboarding4.validate()) {
        this.nextLoading = true;

        await this.addMenu();
        await this.updateMeta();

        // Goto next state
        setTimeout(() => {
          this.$router.push("/dashboard");
          this.nextLoading = false;
        }, this.$store.state.snackBarDuration);
      }
    },
    addMore() {
      this.dishNsubCatHolder.push({ dish: "", subCat: "", price: "" });
    },
    removeItem(index) {
      if (this.dishNsubCatHolder.length > 1) {
        this.dishNsubCatHolder.splice(index, 1);
      }
    },
    async addMenu() {
      let data = { data: this.dishNsubCatHolder };
      axios
        .post("/api/v1/menu", data, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Categories added";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          // Goto next state
          setTimeout(() => {
            this.$router.push("/dashboard");
            this.nextLoading = false;
          }, this.$store.state.snackBarDuration);
        })
        .catch(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Submission failed";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          this.nextLoading = false;
        });
    },
    async updateMeta() {
      let meta = this.storedUserDetails.meta;
      meta.onboarding.stage = 4;
      meta.onboarding.status = "complete";

      await this.$store
        .dispatch("updateUserProfile", { meta: meta })
        .catch((error) => {
          this.snackBar.active = true;
          this.snackBar.text = "Onboarding Stage not updated";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          return error.response.status;
        });
    },
  },
  created() {
    this.$store.dispatch("getUserDetails");
    this.$store.dispatch("getAllCategories");
  },
  computed: {
    ...mapState(["storedUserDetails", "subCategories", "categories"]),
  },
};
</script>

<style scoped>
.main-body {
  font-family: "Montserrat";
}

.flex2 {
  padding-top: 4%;
  background: white;
}

.flex2-content {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

.content-area {
  padding-top: 15%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.footer {
  padding-top: 70%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  color: white;
}

.icon {
  color: green;
  margin-right: 2%;
}

p {
  margin-top: 5%;
}

.link {
  color: #ffffff;
  text-decoration: none;
}

.content-list:hover {
  background: #444444;
  border-radius: 2px;
}

form {
  padding-top: 2%;
}

.form-area {
  width: 50%;
}

#next-btn {
  float: right;
  text-transform: capitalize;
  width: 70%;
}

.form-group {
  width: 95%;
}

.btn-add-more {
  float: right;
}

.v-text-field--outlined.v-input--dense .v-label {
  top: 14px;
}

/* @media only screen and (max-device-width: 480px) {
    .row {
        margin-top: 15%;
    }
} */
</style>
